import createAsyncSlice from "../utils/createAsyncSlice";

const accounts = createAsyncSlice({
  name: "accounts",
  initialState: {
    data: [],
  },
});

export const fetchAccounts = accounts.asyncAction;
export const { resetState: resetAccountsState } = accounts.actions;
export default accounts.reducer;
